export const zqn = {
  banner: 
    {
      title: '找企鸟<span>TOB获客</span>',
      text: '海量线索，找商机，查企业，<Br />查工商，筛选意向客户加速成交',
      img: require('../assets/img/zqn/banner1.png'),
    },
  modular1: {
    titleData: {
      title: 'TOB销售线索平台,解决企业获客难题',
    },
    list:[
      {
        img: require('../assets/img/zqn/TOB-1.png'),
        h4:'强大的搜索引擎',
        p:'多种条件组合，查询获取精准客户'
      },
      {
        img: require('../assets/img/zqn/TOB-2.png'),
        h4:'多维度触达客户',
        p:'多重维度筛选客户，多重联系方式触达客户'
      },
      {
        img: require('../assets/img/zqn/TOB-3.png'),
        h4:'高质量线索池',
        p:'覆盖全网数据，找到专属您的客户'
      }
    ]
  },
  modular2:{
    titleData: {
      title: '解决企业四大困局',
    },
    list:[
      {
        img: require('../assets/img/zqn/icon-1.png'),
        h4:'高质量线索少，获客成本高',
        p:'市场规模有限，竞争对手增加，高质量线索难寻，获客成本逐步提高'
      },
      {
        img: require('../assets/img/zqn/icon-2.png'),
        h4:'客户资源不精准，成交难',
        p:'市面主流获客渠道，获客成本相对较低，但线索质量低下，信息少，难成交。'
      },
      {
        img: require('../assets/img/zqn/icon-3.png'),
        h4:'获客效率低',
        p:'销售每天工作10小时，要花3个小时在网上、线下找资源，费时费力。'
      },
      {
        img: require('../assets/img/zqn/icon-4.png'),
        h4:'客户来源不稳定',
        p:'客户来自不同渠道，时间不定，数量不定，质量不定。'
      },
    ]
  },
  modular3:{
    titleData: {
      title: '选择我们的四大优势',
    },
    list:[
      {
        img: require('../assets/img/zqn/tu1.png'),
        h4:'覆盖全网企业信息商机实时更新',
        p:'上亿家企业客户资源线索及工商信息实时更新，每天商机不断'
      },
      {
        img: require('../assets/img/zqn/tu2.png'),
        h4:'多维度标签丰富快速精准匹配',
        p:'上万个标签，精准划分企业类型，多维度触达，筛选高质量精准客户'
      },
      {
        img: require('../assets/img/zqn/tu3.png'),
        h4:'行业覆盖全领域',
        p:'多行业维度企业资料收集，满足您的维度需求快速开启拓客'
      },
      {
        img: require('../assets/img/zqn/tu4.png'),
        h4:'无缝对接CRM库',
        p:'获取的潜在客户可批量上传，快速查询，一键补全慧营销中的客户信息，加速成交'
      },
    ]
  },
  modular4: {
    titleData: {
      title: '低成本获取高意向客户',
    },
    titleData2: {
      title: '提升效能加速成交',
    },
    conList: [{
        title: '获取上亿条线索',
        img: require('../assets/img/zqn/img1.png'),
        list: [' <span>查企业：</span>支持多种查询条件，让销售人员快速精准找到企业。企业工商信息、联系方式、知识产权、经营状态等企业信息随时查询，实时更新。',
        '<span>找线索:</span>提供200多个筛选条件，可通过关键词进行高精度筛选，智能精准定位目标客户。',
        '<span>批量查企业：</span>支持企业名录导入，系统自动匹配信息，快速补全企业信息，补全后支持导出存档。'
      ],
        bg: '#f1f5ff',
        icon: require('../assets/img/zqn/icon1.png'),
      },
      {
        title: '多维度筛选，精准触达',
        img: require('../assets/img/zqn/img2.png'),
        list: ['通过行业模板、多维度筛选条件、地图检索等，获取精准客户，快速精准触达高质量目标客户群。',
          '<span>行业模板：</span>提供几十个行业模板，点击使用即可完成筛选条件的组合搭配。',
          '<span>地图检索：</span>根据地理位置精准探查，获取公司信息。'
        ],
        icon: require('../assets/img/zqn/icon1.png'),
      },
      {
        title: '管理线索',
        img: require('../assets/img/zqn/img3.png'),
        list: ['<span>线索领取：</span>管理解锁领取线索，可重新分配，领取至我的资源或待分配资源。',
          '<span>及时跟进线索：</span>跟进中的线索、跟进中的联系人、公海线索清晰分类，销售跟进更及时。',
        ],
        icon: require('../assets/img/zqn/icon1.png'),
        bg: '#f1f5ff',
      },
      {
        title: '统计分析',
        img: require('../assets/img/zqn/img4.png'),
        list: ['线索统计，基于线索的使用量和效果，可视化地生成数据报表，帮助企业快速搭建完善的薪酬激励体系，提升人员效能，及时地发现问题，解决问题，及时调整经营管理方式，制定销售策略。',
        ],
        icon: require('../assets/img/zqn/icon1.png'),
      }
    ]
  },
}
